import React from 'react';
import Layout from '../../components/Layout';
import DoNotSell from './DoNotSell';

// CCPA/CPRA §1798.135 — PUBLIC "Do Not Sell or Share My Personal Information"
// page. Must be reachable from the footer without logging in (the disclosure is
// required for all visitors). The opt-out toggle itself only persists for
// logged-in users (handled inside the component).
function action({ store }) {
  const title = store.getState().siteSettings?.data?.siteTitle;
  const description = store.getState().siteSettings?.data?.metaDescription;
  const isAuthenticated = store.getState().runtime.isAuthenticated;

  return {
    title: `Do Not Sell or Share My Personal Information — ${title || 'BestHand'}`,
    description: description || 'BestHand does not sell or share your personal information.',
    component: (
      <Layout>
        <div className={isAuthenticated ? 'subPageMainContainer' : 'withoutPageMainContainer'}>
          <DoNotSell />
        </div>
      </Layout>
    ),
  };
}

export default action;
